import { Badge } from "@/app/components/ui/badge";
import { cn } from "@/lib/utils";
import { Cross1Icon } from "@radix-ui/react-icons";
import { Flex, Text } from "@radix-ui/themes";

interface Props {
  text: string;
  onClick: () => void;
  className?: string;
}

export default function FilterBadge({ text, onClick, className }: Props) {
  return (
    <Badge
      className={cn(
        "gap-3 flex items-center rounded-none text-sm font-normal py-2 px-3 cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      <Flex direction={"column"}>
        <Text>{text}</Text>
      </Flex>
      <Cross1Icon className="h-3 w-3" />
    </Badge>
  );
}
